import React, { useEffect } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/team.png';
import { Wrapper } from './Landing';
import Quote from '../components/Quote';

const Team = () => {
  useEffect(() => {
    document.title = 'Emprouen Advisors: Team';
  }, []);

  return (
    <Wrapper>
      <PageGraphic src={imgGrpahic} />
      <div>
        <h2>Team</h2>

        <Quote>
          We’ve built a seasoned bench of professionals, who are tapped and
          deployed when there's defined needs. This avoids the canned approach,
          so typical in the advisory space.
        </Quote>

        <h3 style={{ marginBottom: '0.5em' }}>Lee Dorkin</h3>

        <h4 style={{ marginBottom: '1.6em' }}>Founder</h4>

        <p>
          Lee began his career in financial services as a registered securities
          trader and money manager for Wall Street investment firms. In
          management consulting, he led process improvement and ERP engagements
          for a regional accounting firm. After 10 years as a practitioner, his
          past 20 years have been spent in turnaround, interim leadership and
          board roles, supporting private equity and SPAC portfolios with
          structure, efficiency and financial discipline strategies. Lee advises
          private and publicly traded M&A transactions with pre-due diligence,
          post-integration and performance oversight. He was interviewed by
          business news, filmed for TV, paneled seminars, published trade
          articles and was the technical expert for a government economics
          initiative. Lee was head of specialized pharmaceutical acquisition in
          the North American for a major health and fitness company. His
          credentials include Certified Six Sigma Black Belt and FINRA
          Securities Series 7.
        </p>

        <h4>Differentiators</h4>

        <p>
          Lee works to guide trust-based cultures as a servant leader, build
          dynamic teams, create structure, communicate mission statements, set
          goals, and align tactics to processes and metrics. Performance
          initiatives are designed to maximize resources, eliminate waste,
          increase efficiency, and reach financial targets.
        </p>
      </div>
    </Wrapper>
  );
};

export default Team;
